/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ArrowEnter({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7.4 3.5a.6.6 0 0 1 .6-.6h2a3.6 3.6 0 0 1 0 7.2H4.449l1.975 1.976a.6.6 0 0 1-.848.848l-3-3a.6.6 0 0 1 0-.848l3-3a.6.6 0 0 1 .848.848L4.45 8.9H10a2.4 2.4 0 1 0 0-4.8H8a.6.6 0 0 1-.6-.6" clipRule="evenodd" /></svg>;
}
;